module.exports = __webpack_public_path__ + "static/media/2019_IMG_8141.53b698aa.jpg";